import { openConflictModal } from 'redux/modules/common-modal/actions/open-conflict-modal';
import { transformProductConflict } from 'redux/modules/conflicts/reducer/transform';

export const handleTrolleyConflicts = dispatch => result => {
  const { trolley: { conflicts = [] } = {} } = result.trolley
    ? result
    : Object.values(result.data)[0];
  if (conflicts.length) {
    const normalisedConflict = transformProductConflict(conflicts[0]);
    dispatch(openConflictModal(normalisedConflict));
  }
};
